import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { IoClose } from "react-icons/io5";
import "../../assets/css/NotificationPopup.css";

const InAppNotificationPopup = ({ notification, onClose }) => {
  const history = useHistory();
  const [isClosing, setIsClosing] = useState(false);
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    if (!notification) return;
    setIsClosing(false);
    setImageError(false);

    const timer = setTimeout(() => {
      handleClose();
    }, 7000); // 7s auto-dismiss

    return () => clearTimeout(timer);
  }, [notification]);

  if (!notification) return null;

  const handleClose = (e) => {
    if (e && typeof e.stopPropagation === "function") {
      e.stopPropagation();
    }
    setIsClosing(true);
    setTimeout(() => {
      if (typeof onClose === "function") {
        onClose();
      }
    }, 280);
  };

  const handleClick = () => {
    handleClose();
    history.push("/notification");
  };

  const baseUrl = process.env.REACT_APP_API_BASE_URL || "https://bk.kingmastar.in";
  let imageUrl = notification.image;
  if (imageUrl && typeof imageUrl === "string" && !imageUrl.startsWith("http")) {
    imageUrl = `${baseUrl}${imageUrl.startsWith("/") ? "" : "/"}${imageUrl}`;
  }

  return (
    <div
      className={`inapp-notification-wrapper ${
        isClosing ? "fade-out" : "slide-in"
      }`}
    >
      <div className="inapp-notification-card" onClick={handleClick}>
        <div className="inapp-notification-header">
          <div className="inapp-header-left">
            <div className="inapp-app-badge">
              <img
                src="/logo.png"
                alt="App"
                className="inapp-logo"
                onError={(e) => {
                  e.target.style.display = "none";
                }}
              />
            </div>
            <span className="inapp-app-name">King Mastar</span>
            <span className="inapp-dot">•</span>
            <span className="inapp-time">Just now</span>
          </div>
          <button
            type="button"
            className="inapp-close-btn"
            onClick={handleClose}
            aria-label="Close notification"
          >
            <IoClose />
          </button>
        </div>

        <div className="inapp-notification-content">
          <div className="inapp-text-block">
            <h4 className="inapp-title">
              {notification.title || "New Notification"}
            </h4>
            {notification.body && (
              <p className="inapp-body">{notification.body}</p>
            )}
          </div>

          {imageUrl && !imageError && (
            <div className="inapp-image-wrap">
              <img
                src={imageUrl}
                alt="Notification"
                className="inapp-media-img"
                onError={() => setImageError(true)}
              />
            </div>
          )}

          <div className="inapp-action-hint">
            <span>Tap to open ›</span>
          </div>
        </div>

        <div className="inapp-progress-bar"></div>
      </div>
    </div>
  );
};

export default InAppNotificationPopup;
